export default __webpack_public_path__ + "static/media/avatarEditBg.de0640bc.svg";